import styled from 'styled-components';

export const UGCPersuasions = styled.div(
  props => `
  width:50%;
  padding-right:${props.theme.spacing.base};
`,
);

export const UGCPersuasionsInnerWrap = styled.div(
  props => `
  display: flex;
  flex-wrap:wrap;
  flex-direction: column;
  border: ${props.theme.misc.border.base} solid ${props.theme.colors.goBrandBlue.light};
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
`,
);

export const ReadAllReviewLink = styled.a(
  props => `
  display:inline-flex;
  cursor: pointer;
  padding-left:${props.theme.spacing.base};
  padding-right:${props.theme.spacing.base};
  color: ${props.theme.colors.goBrandBlue.base};
  &:hover{
    color: ${props.theme.colors.goBrandBlue.base};
  }
  position: absolute;
  bottom: ${props.theme.spacing.base};
  left: 0;
`,
);

export const UGCOuterWrapper = styled.div(
  props => `
  position:relative;
  border-top: ${props.theme.misc.border.base} solid ${props.theme.colors.goBrandBlue.light};
`,
);
